import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.75 8.25H10.5V3H8.25V8.25H3V10.5H8.25V15.75H10.5V10.5H15.75V8.25Z",
		fill: "currentColor"
	})
});
export default SvgPlus;
